import waypoint from 'waypoints/lib/jquery.waypoints';
import inview from 'waypoints/lib/shortcuts/inview';

export function waypoints()
{
    var waypoints = $('.fx').waypoint({

        handler: function (direction) {
            let _this = $(this)[0]['element'];

            $(_this).addClass('active');

        },
        offset: '85%'
    });

}



// WEBPACK FOOTER //
// ./scripts/modules/inview.js